<script setup lang="ts">
import { computed } from 'vue';
import Icon from '@components/Icon.vue';
import Typography from '@components/Typography.vue';
import type { Color } from '@global-types/colors.ts';
import { type Url } from '@global-types/url';

interface DesktopVerticalMenuLinkProps {
  link: Url,
  icon?: string,
  iconName?: string,
  hasIconStroke?: boolean,
  isCollapsed: boolean,
  isActive?: boolean,
  isOpen?: boolean,
  notificationsCount?: number,
}

const props = defineProps<DesktopVerticalMenuLinkProps>();

const iconColor = computed<Color>(() => (props.isActive ? 'black' : 'gray-darker'));
</script>

<template>
  <a
    :href="link"
    class="side-bar-menu__link side-bar-menu__title--no-caret vertical-menu-item vertical-menu-item--link"
    :class="{
      'side-bar-menu-link__active': isOpen,
      'side-bar-menu--current-page': isActive,
    }"
  >
    <div v-if="icon" class="vertical-menu-item__icon" :class="typeof icon === 'string' ? icon : ''">
      <Icon
        v-if="hasIconStroke"
        :svg="icon"
        :custom-class="iconName"
        height="24"
        width="24"
        fill="none"
        :stroke="iconColor"
      />
      <Icon
        v-else
        :svg="icon"
        :custom-class="iconName"
        height="24"
        width="24"
        :fill="iconColor"
      />
      <span
        v-if="notificationsCount"
        class="side-bar-menu__pin"
      />
    </div>

    <Typography
      v-if="!isCollapsed"
      :variant="isActive ? 'body-small-bold' : 'body-small'"
    >
      <slot />

      <template v-if="notificationsCount">
        ({{ notificationsCount }})
      </template>
    </Typography>
  </a>
</template>
